// src/api/userService.js
import axios from "./axiosConfig";

const userService = {
  login(data) {
    return axios.post("/auth/login", data);
  },
  getProfile(user) {
    return axios.get("/auth/me", user);
  },
  previewPrivileges(userId) {
    return axios.post(`/auth/preview/${userId}`);
  },
  register(data) {
    return axios.post("/auth/register", data);
  },

  // Administración
  getAllUsers() {
    return axios.get("/users");
  },
  updateUser(id, data) {
    return axios.put(`/users/${id}`, data);
  },
  deleteUser(id) {
    return axios.delete(`/users/${id}`);
  }
};

export default userService;
